import { useTranslation } from "react-i18next"
import ReactSpinner from "react-svg-spinner"

import { Modal } from "../Modal"

export type MobileSpinnerProps = {
	ariaLabel?: string
	color: string
	size: string
	isOpen: boolean
}

export const MobileSpinner = ({
	ariaLabel = "Waiting loader",
	color,
	size,
	isOpen,
}: MobileSpinnerProps) => {
	const { t } = useTranslation()

	return (
		<Modal isOpen={isOpen} setIsOpen={() => {}} isPreventClosing={true} className="mt-auto">
			<div className="flex flex-col justify-center items-center">
				<ReactSpinner aria-label={ariaLabel} color={color} size={size} />
				<p className="mt-3">{t("global.loading")}</p>
			</div>
		</Modal>
	)
}
